const basePath = process.env.REACT_APP_BASEPATH;

const ForgotPasswordLink = () => (
  <div style={{ textAlign: "center", marginTop: "10px" }}>
    <a href={`${basePath}/forgot-password`} style={{ textDecoration: "none", color: "#007BFF" }}>
      Forgot Password?
    </a>
  </div>
);

export default ForgotPasswordLink;